import { render, staticRenderFns } from "./WizardProps.vue?vue&type=template&id=5c40f8e6"
import script from "./WizardProps.vue?vue&type=script&lang=js"
export * from "./WizardProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports